import { COLUMNS, data, TYPELIST } from './partten';
export default {
  data() {
    return {
      form: {},
      COLUMNS,
      TYPELIST,
      data: [],
      organizationlist: [{
        id: '1',
        name: '泛华保险服务集团'
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  methods: {
    getDataFun() {},
    getSearchFun() {
      this.pagination.current = 1;
      this.data = data;
      this.getDataFun();
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleReport() {
      let that = this;
      this.$confirm({
        content: that.$t('确认要统计报表吗?'),
        okText: that.$t('确认'),
        cancelText: that.$t('取消'),
        onOk() {
          that.$message.success(that.$t('统计成功！可前往“人身险业务报表”查看报表详情'));
        }
      });
    }
  }
};